// utils/thumbnails/useThumbnail.js
import { useState, useCallback } from "react";

import { saveThumbnailToIndexedDB } from "./indexedDBThumbnails";
import { fetchThumbnailsWithCache } from "./fetchThumbnailsWithCache";

export function useThumbnail(resourceType, uploadEndpoint, viewEndpoint) {
  const [url, setUrl] = useState(null);
  const [blob, setBlob] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setIsSaved] = useState(true);
  const [isError, setIsError] = useState(false);
  const [imageInfo, setImageInfo] = useState({ width: null, height: null, sizeKB: null });

  const uploadThumbnail = useCallback(async (file, resource, axiosInstance, preferredSize = "sizeSmall") => {
    if (!file || !resource._id) return;
    const formData = new FormData();
    formData.append("image", file);

    setIsSaving(true);
    setIsSaved(false);
    setIsError(false);

    console.log('HERE12');

    try {
      await axiosInstance.post(`/knovia/${resourceType}/${resource._id}/${uploadEndpoint}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      console.log('HERE13');
      await fetchThumbnail(resource, axiosInstance, preferredSize, { forceRefresh: true });
      setIsSaved(true);
    } catch (err) {
      setIsSaved(false);
      setIsError(true);
      console.error("Upload failed:", err);
    } finally {
      setIsSaving(false);
    }
  }, [uploadEndpoint]);

  const fetchThumbnail = useCallback(async (resource, axiosInstance, preferredSize = "sizeSmall", options = {}) => {
    const { forceRefresh = false } = options;
    if (!resource._id) return;
    setIsLoading(true);

    try {
      const thumbnailMap = await fetchThumbnailsWithCache(
        [resource],
        resourceType,
        preferredSize,
        ({ id, url, blob }) => {
          setBlob(prev => blob);

          if (blob) {
            const newBlobUrl = URL.createObjectURL(blob);
            setUrl(newBlobUrl);

            const sizeKB = (blob.size / 1024).toFixed(1);
            const tempImg = new Image();

            tempImg.onload = () => {
              setImageInfo({ width: tempImg.width, height: tempImg.height, sizeKB });
              URL.revokeObjectURL(tempImg.src); // Clean up
            };
            tempImg.onerror = () => {
              console.warn('Failed to load image for dimension calculation.');
              URL.revokeObjectURL(tempImg.src);
            };
            tempImg.src = newBlobUrl;
          } 
        },
        undefined,
        forceRefresh
      );

    } catch (err) {
      console.warn("Failed to fetch thumbnail:", err);
    } finally {
      setIsLoading(false);
    }
  }, [viewEndpoint]);

  return {
    url,
    isLoading,
    isSaving,
    isSaved,
    isError,
    imageInfo,
    uploadThumbnail,
    fetchThumbnail,
  };
}
